import { db } from "../utils/firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { useState, useEffect } from "react";
import { uuidv4 as uuid } from "@firebase/util";
import { useParams, Link } from "react-router-dom";

const CommunityDashboardListing = () => {
  //   const { community } = useParams();

  const comRef = query(
    collection(db, "Communities"),
    where("status", "==", "active")
  );

  const [communitiesList, setCommunitiesList] = useState([]);

  useEffect(() => {
    const getCommunities = async () => {
      const communitiesFromServer = await getDocs(comRef);
      const propsFromServer = await getDocs(collection(db, "Proposals"));
      const membersFromServer = await getDocs(collection(db, "Users"));

      let communities = [];
      let props = [];
      let members = [];
      communitiesFromServer.forEach((com, i) => {
        const validProps = propsFromServer.docs.filter(
          (prop) => prop.data().community == com.data().name
        );
        validProps.map((r) => {
          if (r.data().community == com.data().name) {
            props.push(r.data());
          }
        });

        const validMembers = membersFromServer.docs.filter(
          (member) => member.data().community == com.data().name
        );

        validMembers.map((m) => {
          if (
            m.data().community == com.data().name &&
            m.data().userTypeNumber < 4
          ) {
            members.push(m.data());
          }
        });

        communities.push({ ...com.data(), id: com.id, props, members });

        setCommunitiesList(communities);
        props = [];
        members = [];
      });
    };
    getCommunities();
  }, []);

  return (
    <div className="container comListing">
      <div className="row">
        <div className="col-3">
          <b>Community</b>
        </div>
        <div className="col-1">
          <b>Funds</b>
        </div>
        <div className="col-3">
          <b>Funds Available</b>
        </div>
        <div className="col-2">
          <b>Funds Used</b>
        </div>
        <div className="col-2">
          <b>Proposals</b>
        </div>
        <div className="col-1">
          <b>Members</b>
        </div>
      </div>

      {communitiesList.map((com) => {
        return (
          <div className="row" key={uuid()}>
            <div className="col-3 col">{com.name}</div>
            <div className="col-1 col">${com.totalFunds}</div>
            <div className="col-3 col">
              {com.totalFunds - com.fundsUsed > 0 ? (
                <span style={{ color: "green" }} color="red">
                  $
                </span>
              ) : (
                <span style={{ color: "red" }}>$</span>
              )}
              {com.totalFunds - com.fundsUsed}
            </div>
            <div className="col-2 col">${com.fundsUsed}</div>
            <div className="col-2 col">
              <Link to={"proposals/" + `${com.slug}`}>{com.props.length}</Link>
            </div>
            <div className="col-1 col">
              <Link to={"members/" + `${com.slug}`}>{com.members.length}</Link>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CommunityDashboardListing;
